function exposeWindow(modules): void {
    window.live = { ...(window.live || {}), ...modules }
}

const expose = (): void => {
    exposeWindow({
        '@mantine/core': require('@mantine/core'),
        '@mantine/hooks': require('@mantine/hooks')
    })
}

expose()
